var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloud2 = function SvgCloud2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cloud-2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.75 31.123H0c10.64-10.92 29.1-20.38 40.39-18.33 7.06 1.29 13.3 5.7 20.4 6.6 9.63 1.21 18.69-4.1 27.43-8.31 15.3-7.37 32.31-11.89 49.26-10.79 16.97 1.12 58.55 13.06 62.27 30.82v.01Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cloud-2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .133)",
    d: "M0 0h199.75v30.99H0z"
  })))));
};
export default SvgCloud2;